import { render, staticRenderFns } from "./purchaseAnalysis.vue?vue&type=template&id=9785c3a0&scoped=true&"
import script from "./purchaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./purchaseAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./purchaseAnalysis.vue?vue&type=style&index=0&id=9785c3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9785c3a0",
  null
  
)

component.options.__file = "purchaseAnalysis.vue"
export default component.exports